export const initialData = {
  nome: '',
  codigo: '',
  potencial_poluidor_id:1
}
export default initialData;
